import { render, staticRenderFns } from "./ExAssignmentModal.vue?vue&type=template&id=3a16bcb8"
import script from "./ExAssignmentModal.vue?vue&type=script&lang=js"
export * from "./ExAssignmentModal.vue?vue&type=script&lang=js"
import style0 from "./ExAssignmentModal.vue?vue&type=style&index=0&id=3a16bcb8&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports